import PropTypes from 'prop-types';

export default {
	id: PropTypes.string.isRequired,
	iconType: PropTypes.string,
	title: PropTypes.string.isRequired,
	isActive: PropTypes.bool,
	className: PropTypes.string,
	notification: PropTypes.string,
	handleSelectTab: PropTypes.func,
};
